<template>
  <v-dialog v-model="dialog" @input="v => v || closeDialog()" max-width="500px">
    <v-card class="card-container">
      <v-card-title>
        <h2 v-if="messageTitle" class="md-title">
          {{ messageTitle | translate }}
        </h2>
      </v-card-title>
      <v-card-text class="px-4 pt-0">
        <v-form ref="changeSettings" v-model="valid" lazy-validation>
          <p class="my-3">{{ "lng_change_controller_label" | translate }}</p>
          <v-text-field
            class="my-2"
            :label="'lng_serial' | translate"
            :rules="nameRules"
            v-model="serialNum"
          ></v-text-field>
          <v-text-field
            class="my-2"
            type="password"
            :rules="passwordRules"
            :label="'lng_password' | translate"
            v-model="password"
          ></v-text-field>
          <p class="my-3">
            {{ "lng_backup_choice_radio_description" | translate }}
          </p>
          <v-radio-group
            :rules="radioRules"
            v-model="radios"
            :mandatory="false"
          >
            <v-radio
              color="rgba(84,110,122,0.87)"
              :label="'lng_backup_0' | translate"
              value="0"
            ></v-radio>
            <v-radio
              color="rgba(84,110,122,0.87)"
              :label="'lng_backup_1' | translate"
              value="1"
            ></v-radio>
            <v-radio
              color="rgba(84,110,122,0.87)"
              :label="'lng_backup_2' | translate"
              value="2"
            ></v-radio>
            <v-radio
              color="rgba(84,110,122,0.87)"
              :label="'lng_backup_3' | translate"
              value="3"
            ></v-radio>
          </v-radio-group>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-layout row wrap>
          <v-flex xs6 class="pr-2">
            <v-btn class="raised-btn" block flat @click="closeDialog"
              >Cancel</v-btn
            >
          </v-flex>
          <v-flex xs6 class="pl-2">
            <v-btn class="primary-btn" block flex xs12 flat @click="validate"
              >Start</v-btn
            >
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ChangeController",
  data() {
    return {
      valid: true,
      nameRules: [v => !!v || "Name is required"],
      passwordRules: [v => !!v || "password is required"],
      radioRules: [v => !!v || "select a value"],
      dialog: false,
      serialNum: "",
      password: "",
      radios: undefined
    };
  },
  props: {
    messageTitle: {
      type: String,
      default: "lng_change_controller_title"
    },
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
    }
  },
  methods: {
    validate() {
      const that = this;
      this.$nextTick(async function() {
        if (that.$refs.changeSettings.validate()) {
          await this.saveSettings();
        }
      });
    },
    saveSettings() {
      let data = {
        serial: this.serialNum,
        password: this.password,
        radio: this.radios
      };
      this.$emit("save-controller", data);
    }
  }
};
</script>
<style scoped>
.card-container {
  overflow-y: auto;
  height: 250px;
}
.def-btn {
  color: rgb(84, 110, 122);
}
.md-title {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.005em;
}
.primary-btn {
  background-color: rgb(84, 110, 122);
  color: #fff !important;
}
</style>
